/**
 * `cn(...)` — clsx + tailwind-merge wrapper.
 *
 * Lets us conditionally combine classes AND have later utilities win
 * conflicts (so `cn('p-2', condition && 'p-4')` actually applies p-4).
 */
import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
